module.exports = __webpack_public_path__ + "static/media/property.850edefc.svg";